import { useContext } from 'react';
import { PaginationFilterContext } from '../context/pagination.context';

export const usePaginationFilter = () => {
    const context = useContext(PaginationFilterContext);
    if (!context) {
        throw new Error("usePagination must be used within a PaginationProvider");
    }
    return context;
};